var map = {
	"./arrow_w_text_ENG.svg": 6876,
	"./arrow_w_text_SE.svg": 725,
	"./cover.svg": 2057,
	"./design_arrow.svg": 7575,
	"./icon_00.svg": 5059,
	"./icon_01.svg": 3694,
	"./icon_02.svg": 1682,
	"./icon_03.svg": 4806,
	"./icon_04.svg": 5763,
	"./icon_05.svg": 7692,
	"./icon_06.svg": 3409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3484;